import Cookie from './cookie.js';



export default class GoogleAnalytics
{
    constructor(uacode)
    {
        if (typeof GoogleAnalytics.instance == 'object') {
            return GoogleAnalytics.instance;
        }

        this.uacode = uacode;
        GoogleAnalytics.instance = this;

        return this;
    }

    init() {
        console.info('Initialize Google Analytics');
        
        if (this.isActive() == false) {
            this.disable();        
        }
    }
    
    getCookieName() {
        return 'ga-disable-' + this.uacode;
    }
    
    isActive() {
        return Cookie.hasValue(this.getCookieName(), 'true') == false;
    }
    
    loadScript() {
        // Append scripts
        if (this.isActive() == false) {
            return;
        }
    
        console.info('Loading Google Analytics Script');
    
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://www.google-analytics.com/analytics.js';
        document.getElementsByTagName('head')[0].appendChild(script);
    
        
        window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
        
        ga('create', this.uacode, 'auto');
        ga('set', 'anonymize_ip', true);
        ga('send', 'pageview');
    }
    
    disable() {
        window[this.getCookieName()] = true;
        console.info('Disabled Google Analytics', this.getCookieName());
    }
    
    optOut() {
        // Set cookie
        console.info('Opted out from Google Analytics');
        Cookie.set(this.getCookieName(), true, 365, '/');
        this.disable();
    }
    
    optIn() {
        // Set cookie
        console.info('Opted in to Google Analytics');
        Cookie.set(this.getCookieName(), false, 365, '/');
        this.loadScript();   
    }    
}



function gaOptout () {
    (new GoogleAnalytics()).optOut();
    alert('Google Analytics wurde deaktiviert');
}


export {GoogleAnalytics, gaOptout};